import { useQuery } from '@tanstack/react-query';

// helpers
import { BaseError } from '../../helpers/BaseError';

// models
import {
    TOP_PERFORMING_METRICS,
    TopLabelsMetricModel,
} from '../../models/metrics.model';

// services
import API from '../../services/api';

// keys
import metricKeys from './_queryKeys';

const getTopLabelsMetrics = async (
    metric_name: TOP_PERFORMING_METRICS,
    variant_type: string,
): Promise<TopLabelsMetricModel[]> => {
    const { data } = await API.getTopLabelMetric({
        metric_name,
        n_days: 30,
        n_items: 5,
        variant_type,
    });
    return data;
};

export default function useGetTopLabelsMetrics(
    metric_name: TOP_PERFORMING_METRICS,
    variant_type: string,
) {
    return useQuery<TopLabelsMetricModel[], BaseError>({
        queryKey: metricKeys.topLabelMetrics(metric_name, variant_type),
        queryFn: () => getTopLabelsMetrics(metric_name, variant_type),
    });
}
